import { startCase } from 'lodash'

import colors from '~/styles/_colors.css'
import { MfgPartnerLevelType } from '~/__generated__/globalTypes'

export const JOBS = 'jobs'
export const FAILURES = 'failures'
export const EXCEPTION_FAILURES = 'exceptionfailures'
export const CAPABILITIES = 'capabilities'
export const PERFORMANCE = 'performance'
export const PROCESS_AVAILABILITY = 'processavailability'
export const MATERIAL_AVAILABILITY = 'materialavailability'
export const MOBILE_WIDTH = 576

export const MPListTopSearchFilterKeys = Object.freeze({
    MP_NAME: 'mpName',
})
export const YEAR_FIRST_DATE_FORMAT = 'YYYY-MM-DD, HH:mm z'

export const MfgPartnerSortMapping: { [key: string]: string } = {
    name_ascend: 'NAME_ASC',
    name_descend: 'NAME_DESC',
    countryName_ascend: 'COUNTRY_ASC',
    countryName_descend: 'COUNTRY_DESC',
    openJobsCount_ascend: 'OPEN_JOBS_ASC',
    openJobsCount_descend: 'OPEN_JOBS_DESC',
    openFailuresCount_ascend: 'OPEN_FAILURES_ASC',
    openFailuresCount_descend: 'OPEN_FAILURES_DESC',
    openCarsCount_ascend: 'OPEN_CARS_ASC',
    openCarsCount_descend: 'OPEN_CARS_DESC',
    acceptanceRating_ascend: 'ACCEPTANCE_RATIO_ASC',
    acceptanceRating_descend: 'ACCEPTANCE_RATIO_DESC',
    expirationRating_ascend: 'EXPIRATION_RATIO_ASC',
    expirationRating_descend: 'EXPIRATION_RATIO_DESC',
    onTimeRating_ascend: 'OT_RATIO_ASC',
    onTimeRating_descend: 'OT_RATIO_DESC',
    inFullRating_ascend: 'IF_RATIO_ASC',
    inFullRating_descend: 'IF_RATIO_DESC',
    carTurnAround_ascend: 'CAR_TURNAROUND_DAYS_ASC',
    carTurnAround_descend: 'CAR_TURNAROUND_DAYS_DESC',
}

export const MP_DETAILS_TABS = {
    JOBS,
    FAILURES,
    EXCEPTION_FAILURES,
    CAPABILITIES,
    PERFORMANCE,
    PROCESS_AVAILABILITY,
    MATERIAL_AVAILABILITY,
} as const

export const TABS_WITH_TOP_SEARCH = Object.freeze({
    [MP_DETAILS_TABS.JOBS]: JOBS,
    [MP_DETAILS_TABS.FAILURES]: FAILURES,
    [MP_DETAILS_TABS.EXCEPTION_FAILURES]: EXCEPTION_FAILURES,
})

export const JobsListTopSearchOptions = [
    { value: `${MP_DETAILS_TABS.JOBS}_jobRequestName`, name: 'Job' },
    { value: `${MP_DETAILS_TABS.JOBS}_salesOrder`, name: 'Sales order' },
]

export const FailuresTopSearchOptions = [
    { value: `${MP_DETAILS_TABS.FAILURES}_exceptionId`, name: 'Exception ID' },
    { value: `${MP_DETAILS_TABS.FAILURES}_carId`, name: 'CAR ID' },
    { value: `${MP_DETAILS_TABS.FAILURES}_salesOrder`, name: 'Sales order' },
    { value: `${MP_DETAILS_TABS.FAILURES}_jobRequestName`, name: 'Job' },
]

export const ExceptionFailuresTopSearchOptions = [
    {
        value: `${MP_DETAILS_TABS.EXCEPTION_FAILURES}_exceptionId`,
        name: 'Exception ID',
    },
    { value: `${MP_DETAILS_TABS.EXCEPTION_FAILURES}_carId`, name: 'CAR ID' },
    {
        value: `${MP_DETAILS_TABS.EXCEPTION_FAILURES}_salesOrder`,
        name: 'Sales order',
    },
    {
        value: `${MP_DETAILS_TABS.EXCEPTION_FAILURES}_jobRequestName`,
        name: 'Job',
    },
]

export const MpDetailsTabOptions = {
    [MP_DETAILS_TABS.JOBS]: {
        defaultIndex: JobsListTopSearchOptions.findIndex(
            option => option.value === `${MP_DETAILS_TABS.JOBS}_jobRequestName`,
        ),
        options: JobsListTopSearchOptions,
    },
    [MP_DETAILS_TABS.FAILURES]: {
        defaultIndex: FailuresTopSearchOptions.findIndex(
            option =>
                option.value === `${MP_DETAILS_TABS.FAILURES}_exceptionId`,
        ),
        options: FailuresTopSearchOptions,
    },

    [MP_DETAILS_TABS.EXCEPTION_FAILURES]: {
        defaultIndex: ExceptionFailuresTopSearchOptions.findIndex(
            option =>
                option.value ===
                `${MP_DETAILS_TABS.EXCEPTION_FAILURES}_exceptionId`,
        ),
        options: ExceptionFailuresTopSearchOptions,
    },
} as const

export const PREFERENCES_PROPERTIES = ['width']

export const EXCEPTION_STATUS = Object.freeze({
    OPEN_FAILURE: 'Open failure',
    CLOSED_FAILURE: 'Closed failure',
    OPEN_EXCEPTION: 'Open exception',
    CLOSED_EXCEPTION: 'Closed exception',
    VOIDED_EXCEPTION: 'Voided exception',
})

export const EXCEPTION_STATUS_TAGS: {
    [key: string]: { color: string; title: string }
} = {
    [EXCEPTION_STATUS.OPEN_EXCEPTION]: {
        color: 'blue',
        title: EXCEPTION_STATUS.OPEN_EXCEPTION,
    },
    [EXCEPTION_STATUS.OPEN_FAILURE]: {
        color: 'red',
        title: EXCEPTION_STATUS.OPEN_FAILURE,
    },
    [EXCEPTION_STATUS.CLOSED_FAILURE]: {
        color: 'green',
        title: EXCEPTION_STATUS.CLOSED_FAILURE,
    },
    [EXCEPTION_STATUS.VOIDED_EXCEPTION]: {
        color: colors.gray2,
        title: EXCEPTION_STATUS.VOIDED_EXCEPTION,
    },
    [EXCEPTION_STATUS.CLOSED_EXCEPTION]: {
        color: 'green',
        title: EXCEPTION_STATUS.CLOSED_EXCEPTION,
    },
}

export const MP_FAILURE_TYPE = Object.freeze({
    OT: 'OT',
    IF: 'IF',
    OTIF: 'OTIF',
})

export const MP_FAILURE_TYPE_TAGS: {
    [key: string]: { color: string; title: string }
} = {
    [MP_FAILURE_TYPE.OT]: {
        color: 'orange',
        title: MP_FAILURE_TYPE.OT,
    },
    [MP_FAILURE_TYPE.IF]: {
        color: 'orange',
        title: MP_FAILURE_TYPE.IF,
    },
    [MP_FAILURE_TYPE.OTIF]: {
        color: 'orange',
        title: MP_FAILURE_TYPE.OTIF,
    },
}

export const MP_PRIORITY_FILTERS = [
    {
        LABEL: 'Very Urgent',
        VALUE: 'very_urgent',
    },
    {
        LABEL: 'Urgent',
        VALUE: 'urgent',
    },
    {
        LABEL: 'Normal',
        VALUE: 'normal',
    },
    {
        LABEL: 'Not Urgent',
        VALUE: 'not_urgent',
    },
] as const

export const MP_JOB_REQUEST_STATUS_FILTERS = [
    {
        LABEL: 'Closed',
        VALUE: 'Closed',
    },
    {
        LABEL: 'Accepted',
        VALUE: 'Accepted',
    },
    {
        LABEL: 'In secondary processing',
        VALUE: 'Secondary processing',
    },
    {
        LABEL: 'Inspection submitted',
        VALUE: 'Inspection submitted',
    },
] as const

export const LISTS_PAGINATION_LIMIT = 40
export const MAX_PROJECT_NAME_LENGTH = 20
export const PLACEMENT = 'mp-job-request-list-page'

export const MP_LEVEL_FILTERS = [
    {
        LABEL: startCase(MfgPartnerLevelType.gold),
        VALUE: MfgPartnerLevelType.gold,
    },
    {
        LABEL: startCase(MfgPartnerLevelType.silver),
        VALUE: MfgPartnerLevelType.silver,
    },
    {
        LABEL: startCase(MfgPartnerLevelType.bronze),
        VALUE: MfgPartnerLevelType.bronze,
    },
    {
        LABEL: startCase(MfgPartnerLevelType.suspended),
        VALUE: MfgPartnerLevelType.suspended,
    },
]

export const BOOLEAN_FILTERS = [
    {
        LABEL: 'Yes',
        VALUE: 'true',
    },
    {
        LABEL: 'No',
        VALUE: 'false',
    },
]

export const MP_LEVEL_METRICS_DECIMAL_PLACES = 2

export const MP_LEVEL_CAR_T_DECIMAL_PLACES = 1
